import "./Quote.scss";
import Card from 'react-bootstrap/Card';
import { useEffect, useRef, useState } from "react";
import loader from "../assets/images/loader.gif";
import { useForm } from "react-hook-form";
import WebService from "../utility/WebService";
import HelperService from "../utility/HelperService";

interface propData {
    data: any
}

const SalesQuoteInfo = (props: propData) => {
    const signature = props?.data?.signatureInfo;

    return (
        <>
            <div className=' '>
                <Card className="card-style form-style p-2" style={{ marginBottom: 50 }}>
                    <Card.Body className="border-bottom border-light">
                        <div className="mb-0 font-w-medium font-15">Quote Description</div>
                        <div dangerouslySetInnerHTML={{ __html: props?.data?.jobDescription }} />
                        <div className="text-end mt-4">
                            {signature?.sign && <img src={signature.signBase64 || `data:image/png;base64,${signature.sign}`} style={{ height: 150, width: 200, objectFit: 'contain' }} />}
                            <div style={{ marginRight: 50, }}>
                                {signature?.signedBy && <div>{signature.signedBy}</div>}
                                {signature?.signedOn && <div>{HelperService.getFormatedDateAndTimeWithoutUTC(signature.signedOn)}</div>}
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    )
}

export default SalesQuoteInfo;